// extracted by mini-css-extract-plugin
export default {"animatedIconSuccess":"AnimatedIconSuccess-module__animatedIconSuccess__ub6pF"};